export default {"src":"/_next/static/media/favorite-active.08fa3c6a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};